export default "__VITE_PUBLIC_ASSET__e6596ede__"